<template>
  <div class="admin_table">
    <div class="admin_table_top">
      <div class="table-title">商品⼀覧</div>
      <paging
        v-if="items.length > 0"
        :total_count="items.length"
        :page="paginationParams.page"
        :styles="'admin-panigation'"
        :total-page="paginationParams.totalPage"
        compact="true"
        @jumpPage="onPageChange"
      />
    </div>
    <table class="sr_ad_table">
      <thead class="">
        <tr>
          <th class="w_20 border_radius_right">画像</th>
          <th class="w_40 large">商品名</th>
          <th class="w_20">単価</th>
          <th class="w_10">単位 </th>
          <th class="w_5 border_radius_left">&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in items"
            :key="index"
        >
          <td v-lazy-container="{ selector: 'img' }" class="item_image" @click="openDetail($event, item)">
            <img class="img_width" :data-src="item.img">
          </td>
          <td class="display_text line_stretch" @click="openDetail($event, item)">{{ item.name }}</td>
          <td @click="openDetail($event, item)">{{ showPrice(item.default_price) }}</td>
          <td @click="openDetail($event, item)">{{ item.unit }}</td>
          <td>
            <div style="position: relative; cursor: pointer;">
              <button class="icon_leader after ml-auto" @click="onTdMenuOpen($event, item)" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-show="items.length === 0" class="text-center">表示するデータはありません。</div>
    <div class="pagination pagination_admin">
      <paging
        v-if="items.length > 0"
        :page="paginationParams.page"
        :styles="'admin-panigation'"
        :total-page="paginationParams.totalPage"
        compact="true"
        @jumpPage="onPageChange"
      />
    </div>
  </div>
</template>

<script>
import { ItemsService } from '../../../../services/admin/item.service';
import Paging from '../../../../components/Pager';
import utils from '../../../../common/util.js';

export default {
  components: {
    Paging,
  },
  props: {
    selectedId: {
      type: Number,
      require: true,
      default: -1
    },
    items: {
      type: Array,
      require: true
    },
    paginationParams: {
      type: Object,
      require: true
    },
  },
  data() {
    return {
    };
  },
  watch: {
    paginationParams: {
      async handler() {
        await this.$emit('refreshTable');
      },
      deep: true
    },
  },
  async mounted() {
    this.$tableTdMenu.classToIgnore = 'icon_leader';
  },
  methods: {
    ...utils,
    openDetail(event, item) {
      this.$emit('updateSelectedItem', item.id);
      this.$openModal('itemForm');
    },
    onTdMenuOpen(event, item) {
      this.$tableTdMenu.menu = [
        {
          'name': '編集する',
          'func': () => {
            this.$emit('updateSelectedItem', item.id, true);
            this.$openModal('itemForm');
          }
        },
        {
          'name': '削除する',
          'class': 'alert',
          'func': () => {
            this.popupConfirmDelete(item);
          }
        }
      ];
      this.$openTdMenu(event);
    },
    onPageChange(page) {
      this.$emit('updateCurrentPage', page);
    },
    async popupConfirmDelete(item) {
      const confirm = await this.$swal.fire({
        title: '削除確認',
        html: `<p>商品を<span class='text_color-reb'>削除</span>します。</p>
               <p>よろしいですか？</p>`,
        confirmButtonText: '決定',
        cancelButtonText: 'キャンセル',
        showCloseButton: false,
        showCancelButton: true,
        confirmButtonClass: 'btn_admin admin_primary',
        cancelButtonClass: 'btn_admin admin_primary_border',
      });

      if (confirm.isConfirmed) {
        try {
          await ItemsService.delete(item.id);
          this.$emit('updateSelectedItem', null);
        } catch (error) {
          console.log(error);
        }
      }
      this.$emit('refreshTable');
    },
  },
};
</script>
<style lang="scss" scoped>
.item_image {
  padding: 8px;

  img {
    object-fit: contain;
    width: 80px;
    height: 80px;

    &[lazy=error], &[lazy=loading] {
      max-height: 24px;
    }
  }
}
</style>